import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { PatronesWltpService } from "../patrones-wltp.service";

@Component({
  selector: "app-selected-datos",
  templateUrl: "./selected-datos.component.html",
  styleUrls: ["./selected-datos.component.scss"],
})
export class SelectedDatosComponent implements OnInit {
  public filtersTable: string;
  filtersTableJSON;
  public filtersSearch = "";

  public maintenancePatronesWltp;
  public operation: string;
  public routing = RoutingConstants.patronWltp;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;

  constructor(
    private patronesWltpService: PatronesWltpService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService
  ) {}

  ngOnInit(): void {
    this.initFormGroup();
    let id = this.activatedRoute.snapshot.params.id;
    this.getDatosWltp(id);
  }

  initFormGroup() {
    this.maintenancePatronesWltp = new FormGroup({
      pwId: new FormControl("", [Validators.maxLength(64)]),
      pwAlturmin: new FormControl("", [Validators.maxLength(64)]),
      pwAnchumin: new FormControl("", [Validators.maxLength(64)]),
      pwAreaFrontal: new FormControl("", [Validators.maxLength(64)]),
      pwAtctfami: new FormControl("", [Validators.maxLength(64)]),
      pwCadiseje: new FormControl("", [Validators.maxLength(64)]),
      pwCateneu1: new FormControl("", [Validators.maxLength(64)]),
      pwCateneu2: new FormControl("", [Validators.maxLength(64)]),
      pwClacicon: new FormControl("", [Validators.maxLength(64)]),
      pwClaseHibrido: new FormControl("", [Validators.maxLength(64)]),
      pwCoElePur: new FormControl("", [Validators.maxLength(64)]),
      pwCoElecAh: new FormControl("", [Validators.maxLength(64)]),
      pwCodispue: new FormControl("", [Validators.maxLength(64)]),
      pwCoefic1: new FormControl("", [Validators.maxLength(64)]),
      pwCoefic2: new FormControl("", [Validators.maxLength(64)]),
      pwCoefic3: new FormControl("", [Validators.maxLength(64)]),
      pwCoguiuni: new FormControl("", [Validators.maxLength(64)]),
      pwCorrelativo: new FormControl("", [Validators.maxLength(64)]),
      pwCuentakm: new FormControl("", [Validators.maxLength(64)]),
      pwDeLlane1: new FormControl("", [Validators.maxLength(64)]),
      pwDeLlane2: new FormControl("", [Validators.maxLength(64)]),
      pwDeNeume1: new FormControl("", [Validators.maxLength(64)]),
      pwDeNeume2: new FormControl("", [Validators.maxLength(64)]),
      pwDeObser1: new FormControl("", [Validators.maxLength(64)]),
      pwDeObser2: new FormControl("", [Validators.maxLength(64)]),
      pwDeObser3: new FormControl("", [Validators.maxLength(64)]),
      pwDeObser4: new FormControl("", [Validators.maxLength(64)]),
      pwDisbomin: new FormControl("", [Validators.maxLength(64)]),
      pwDvfactor: new FormControl("", [Validators.maxLength(64)]),
      pwEvapfami: new FormControl("", [Validators.maxLength(64)]),
      pwFactorVerif: new FormControl("", [Validators.maxLength(64)]),
      pwFactredu: new FormControl("", [Validators.maxLength(64)]),
      pwIndivelo: new FormControl("", [Validators.maxLength(64)]),
      pwIpfamily: new FormControl("", [Validators.maxLength(64)]),
      pwKifamili: new FormControl("", [Validators.maxLength(64)]),
      pwLongimin: new FormControl("", [Validators.maxLength(64)]),
      pwLonzomin: new FormControl("", [Validators.maxLength(64)]),
      pwMarafami: new FormControl("", [Validators.maxLength(64)]),
      pwMasaRealVehic: new FormControl("", [Validators.maxLength(64)]),
      pwMasaTest: new FormControl("", [Validators.maxLength(64)]),
      pwMasaVehicInc: new FormControl("", [Validators.maxLength(64)]),
      pwMotor: new FormControl("", [Validators.maxLength(64)]),
      pwNefzauto: new FormControl("", [Validators.maxLength(64)]),
      pwNefzcemi: new FormControl("", [Validators.maxLength(64)]),
      pwNfCaeExg: new FormControl("", [Validators.maxLength(64)]),
      pwNfCaeExt: new FormControl("", [Validators.maxLength(64)]),
      pwNfCaeUrb: new FormControl("", [Validators.maxLength(64)]),
      pwNfCaeUrg: new FormControl("", [Validators.maxLength(64)]),
      pwNfCoGLas: new FormControl("", [Validators.maxLength(64)]),
      pwNfCo2Las: new FormControl("", [Validators.maxLength(64)]),
      pwNfConCoo: new FormControl("", [Validators.maxLength(64)]),
      pwNfConExo: new FormControl("", [Validators.maxLength(64)]),
      pwNfConLao: new FormControl("", [Validators.maxLength(64)]),
      pwNfConUro: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmCo2C: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmCo2E: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmCo2G: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmCo2L: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmCo2U: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmiCam: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmiCau: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmiCo2: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmiLas: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmiSim: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmiSin: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmiSkm: new FormControl("", [Validators.maxLength(64)]),
      pwNfEmiSko: new FormControl("", [Validators.maxLength(64)]),
      pwNfSkolas: new FormControl("", [Validators.maxLength(64)]),
      pwNuasipro: new FormControl("", [Validators.maxLength(64)]),
      pwNupuerta: new FormControl("", [Validators.maxLength(64)]),
      pwPemsfami: new FormControl("", [Validators.maxLength(64)]),
      pwRaEleEah: new FormControl("", [Validators.maxLength(64)]),
      pwRaElePur: new FormControl("", [Validators.maxLength(64)]),
      pwRaElurAh: new FormControl("", [Validators.maxLength(64)]),
      pwRaElurPu: new FormControl("", [Validators.maxLength(64)]),
      pwRdeComPart: new FormControl("", [Validators.maxLength(64)]),
      pwRdeNoxComp: new FormControl("", [Validators.maxLength(64)]),
      pwRdeNoxUrb: new FormControl("", [Validators.maxLength(64)]),
      pwRdeUrbPart: new FormControl("", [Validators.maxLength(64)]),
      pwReLlane1: new FormControl("", [Validators.maxLength(64)]),
      pwReLlane2: new FormControl("", [Validators.maxLength(64)]),
      pwReNeume1: new FormControl("", [Validators.maxLength(64)]),
      pwReNeume2: new FormControl("", [Validators.maxLength(64)]),
      pwReavfami: new FormControl("", [Validators.maxLength(64)]),
      pwRejareaf: new FormControl("", [Validators.maxLength(64)]),
      pwResistRodEje1: new FormControl("", [Validators.maxLength(64)]),
      pwResistRodEje2: new FormControl("", [Validators.maxLength(64)]),
      pwRoej1min: new FormControl("", [Validators.maxLength(64)]),
      pwRoej2min: new FormControl("", [Validators.maxLength(64)]),
      pwTextNeum: new FormControl("", [Validators.maxLength(64)]),
      pwTipoCambio: new FormControl("", [Validators.maxLength(64)]),
      pwTipoHomol: new FormControl("", [Validators.maxLength(64)]),
      pwVelolimi: new FormControl("", [Validators.maxLength(64)]),
      pwVoladmin: new FormControl("", [Validators.maxLength(64)]),
      pwWCo2Ehot: new FormControl("", [Validators.maxLength(64)]),
      pwWCo2Hiot: new FormControl("", [Validators.maxLength(64)]),
      pwWCo2Lwot: new FormControl("", [Validators.maxLength(64)]),
      pwWCo2Mdot: new FormControl("", [Validators.maxLength(64)]),
      pwWco2Ehga: new FormControl("", [Validators.maxLength(64)]),
      pwWco2Ehgd: new FormControl("", [Validators.maxLength(64)]),
      pwWco2Higa: new FormControl("", [Validators.maxLength(64)]),
      pwWco2Higd: new FormControl("", [Validators.maxLength(64)]),
      pwWco2Lwga: new FormControl("", [Validators.maxLength(64)]),
      pwWco2Lwgd: new FormControl("", [Validators.maxLength(64)]),
      pwWco2Mdga: new FormControl("", [Validators.maxLength(64)]),
      pwWco2Mdgd: new FormControl("", [Validators.maxLength(64)]),
      pwWlAhoDie: new FormControl("", [Validators.maxLength(64)]),
      pwWlAhoGas: new FormControl("", [Validators.maxLength(64)]),
      pwWlAhoOtr: new FormControl("", [Validators.maxLength(64)]),
      pwWlCo2Lag: new FormControl("", [Validators.maxLength(64)]),
      pwWlCo2Las: new FormControl("", [Validators.maxLength(64)]),
      pwWlCo2Lot: new FormControl("", [Validators.maxLength(64)]),
      pwWlConCog: new FormControl("", [Validators.maxLength(64)]),
      pwWlConCol: new FormControl("", [Validators.maxLength(64)]),
      pwWlConCoo: new FormControl("", [Validators.maxLength(64)]),
      pwWlConEhg: new FormControl("", [Validators.maxLength(64)]),
      pwWlConEhl: new FormControl("", [Validators.maxLength(64)]),
      pwWlConEho: new FormControl("", [Validators.maxLength(64)]),
      pwWlConHig: new FormControl("", [Validators.maxLength(64)]),
      pwWlConHil: new FormControl("", [Validators.maxLength(64)]),
      pwWlConHio: new FormControl("", [Validators.maxLength(64)]),
      pwWlConLag: new FormControl("", [Validators.maxLength(64)]),
      pwWlConLal: new FormControl("", [Validators.maxLength(64)]),
      pwWlConLao: new FormControl("", [Validators.maxLength(64)]),
      pwWlConLwg: new FormControl("", [Validators.maxLength(64)]),
      pwWlConLwl: new FormControl("", [Validators.maxLength(64)]),
      pwWlConLwo: new FormControl("", [Validators.maxLength(64)]),
      pwWlConMdg: new FormControl("", [Validators.maxLength(64)]),
      pwWlConMdl: new FormControl("", [Validators.maxLength(64)]),
      pwWlConMdo: new FormControl("", [Validators.maxLength(64)]),
      pwWlEmCo2o: new FormControl("", [Validators.maxLength(64)]),
      pwWlEmiCo2: new FormControl("", [Validators.maxLength(64)]),
      pwWlemCo2g: new FormControl("", [Validators.maxLength(64)]),
    });
  }

  getDatosWltp(id: string) {
    this.patronesWltpService.getpatronWltpEdit("?_id=" + id).subscribe(
      (data) => {
        this.setValues(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje ? err.error.mensaje : "Error al cargar usuario"
        );
      }
    );
  }

  setValues(data) {
    this.maintenancePatronesWltp.patchValue({
      pwId: data.pwId,
      pwAlturmin: data.pwAlturmin,
      pwAnchumin: data.pwAnchumin,
      pwAreaFrontal: data.pwAreaFrontal,
      pwAtctfami: data.pwAtctfami,
      pwCadiseje: data.pwCadiseje,
      pwCateneu1: data.pwCateneu1,
      pwCateneu2: data.pwCateneu2,
      pwClacicon: data.pwClacicon,
      pwClaseHibrido: data.pwClaseHibrido,
      pwCoElePur: data.pwCoElePur,
      pwCoElecAh: data.pwCoElecAh,
      pwCodispue: data.pwCodispue,
      pwCoefic1: data.pwCoefic1,
      pwCoefic2: data.pwCoefic2,
      pwCoefic3: data.pwCoefic3,
      pwCoguiuni: data.pwCoguiuni,
      pwCorrelativo: data.pwCorrelativo,
      pwCuentakm: data.pwCuentakm,
      pwDeLlane1: data.pwDeLlane1,
      pwDeLlane2: data.pwDeLlane2,
      pwDeNeume1: data.pwDeNeume1,
      pwDeNeume2: data.pwDeNeume2,
      pwDeObser1: data.pwDeObser1,
      pwDeObser2: data.pwDeObser2,
      pwDeObser3: data.pwDeObser3,
      pwDeObser4: data.pwDeObser4,
      pwDisbomin: data.pwDisbomin,
      pwDvfactor: data.pwDvfactor,
      pwEvapfami: data.pwEvapfami,
      pwFactorVerif: data.pwFactorVerif,
      pwFactredu: data.pwFactredu,
      pwIndivelo: data.pwIndivelo,
      pwIpfamily: data.pwIpfamily,
      pwKifamili: data.pwKifamili,
      pwLongimin: data.pwLongimin,
      pwLonzomin: data.pwLonzomin,
      pwMarafami: data.pwMarafami,
      pwMasaRealVehic: data.pwMasaRealVehic,
      pwMasaTest: data.pwMasaTest,
      pwMasaVehicInc: data.pwMasaVehicInc,
      pwMotor: data.pwMotor,
      pwNefzauto: data.pwNefzauto,
      pwNefzcemi: data.pwNefzcemi,
      pwNfCaeExg: data.pwNfCaeExg,
      pwNfCaeExt: data.pwNfCaeExt,
      pwNfCaeUrb: data.pwNfCaeUrb,
      pwNfCaeUrg: data.pwNfCaeUrg,
      pwNfCoGLas: data.pwNfCoGLas,
      pwNfCo2Las: data.pwNfCo2Las,
      pwNfConCoo: data.pwNfConCoo,
      pwNfConExo: data.pwNfConExo,
      pwNfConLao: data.pwNfConLao,
      pwNfConUro: data.pwNfConUro,
      pwNfEmCo2C: data.pwNfEmCo2C,
      pwNfEmCo2E: data.pwNfEmCo2E,
      pwNfEmCo2G: data.pwNfEmCo2G,
      pwNfEmCo2L: data.pwNfEmCo2L,
      pwNfEmCo2U: data.pwNfEmCo2U,
      pwNfEmiCam: data.pwNfEmiCam,
      pwNfEmiCau: data.pwNfEmiCau,
      pwNfEmiCo2: data.pwNfEmiCo2,
      pwNfEmiLas: data.pwNfEmiLas,
      pwNfEmiSim: data.pwNfEmiSim,
      pwNfEmiSin: data.pwNfEmiSin,
      pwNfEmiSkm: data.pwNfEmiSkm,
      pwNfEmiSko: data.pwNfEmiSko,
      pwNfSkolas: data.pwNfSkolas,
      pwNuasipro: data.pwNuasipro,
      pwNupuerta: data.pwNupuerta,
      pwPemsfami: data.pwPemsfami,
      pwRaEleEah: data.pwRaEleEah,
      pwRaElePur: data.pwRaElePur,
      pwRaElurAh: data.pwRaElurAh,
      pwRaElurPu: data.pwRaElurPu,
      pwRdeComPart: data.pwRdeComPart,
      pwRdeNoxComp: data.pwRdeNoxComp,
      pwRdeNoxUrb: data.pwRdeNoxUrb,
      pwRdeUrbPart: data.pwRdeUrbPart,
      pwReLlane1: data.pwReLlane1,
      pwReLlane2: data.pwReLlane2,
      pwReNeume1: data.pwReNeume1,
      pwReNeume2: data.pwReNeume2,
      pwReavfami: data.pwReavfami,
      pwRejareaf: data.pwRejareaf,
      pwResistRodEje1: data.pwResistRodEje1,
      pwResistRodEje2: data.pwResistRodEje2,
      pwRoej1min: data.pwRoej1min,
      pwRoej2min: data.pwRoej2min,
      pwTextNeum: data.pwTextNeum,
      pwTipoCambio: data.pwTipoCambio,
      pwTipoHomol: data.pwTipoHomol,
      pwVelolimi: data.pwVelolimi,
      pwVoladmin: data.pwVoladmin,
      pwWCo2Ehot: data.pwWCo2Ehot,
      pwWCo2Hiot: data.pwWCo2Hiot,
      pwWCo2Lwot: data.pwWCo2Lwot,
      pwWCo2Mdot: data.pwWCo2Mdot,
      pwWco2Ehga: data.pwWco2Ehga,
      pwWco2Ehgd: data.pwWco2Ehgd,
      pwWco2Higa: data.pwWco2Higa,
      pwWco2Higd: data.pwWco2Higd,
      pwWco2Lwga: data.pwWco2Lwga,
      pwWco2Lwgd: data.pwWco2Lwgd,
      pwWco2Mdga: data.pwWco2Mdga,
      pwWco2Mdgd: data.pwWco2Mdgd,
      pwWlAhoDie: data.pwWlAhoDie,
      pwWlAhoGas: data.pwWlAhoGas,
      pwWlAhoOtr: data.pwWlAhoOtr,
      pwWlCo2Lag: data.pwWlCo2Lag,
      pwWlCo2Las: data.pwWlCo2Las,
      pwWlCo2Lot: data.pwWlCo2Lot,
      pwWlConCog: data.pwWlConCog,
      pwWlConCol: data.pwWlConCol,
      pwWlConCoo: data.pwWlConCoo,
      pwWlConEhg: data.pwWlConEhg,
      pwWlConEhl: data.pwWlConEhl,
      pwWlConEho: data.pwWlConEho,
      pwWlConHig: data.pwWlConHig,
      pwWlConHil: data.pwWlConHil,
      pwWlConHio: data.pwWlConHio,
      pwWlConLag: data.pwWlConLag,
      pwWlConLal: data.pwWlConLal,
      pwWlConLao: data.pwWlConLao,
      pwWlConLwg: data.pwWlConLwg,
      pwWlConLwl: data.pwWlConLwl,
      pwWlConLwo: data.pwWlConLwo,
      pwWlConMdg: data.pwWlConMdg,
      pwWlConMdl: data.pwWlConMdl,
      pwWlConMdo: data.pwWlConMdo,
      pwWlEmCo2o: data.pwWlEmCo2o,
      pwWlEmiCo2: data.pwWlEmiCo2,
      pwWlemCo2g: data.pwWlemCo2g,
    });
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }
}
